var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social_icons_black"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Github"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-51",
    d: "M24.0432 0.179932C10.8147 0.179932 0.0876465 11.0878 0.0876465 24.5445C0.0876465 35.3096 6.95165 44.4426 16.4699 47.6643C17.6672 47.8899 18.1067 47.1358 18.1067 46.4922C18.1067 45.9112 18.0845 43.9919 18.0742 41.956C11.4097 43.4299 10.0034 39.0812 10.0034 39.0812C8.9137 36.265 7.34358 35.5161 7.34358 35.5161C5.17009 34.0039 7.50742 34.035 7.50742 34.035C9.91297 34.2065 11.1796 36.5458 11.1796 36.5458C13.3162 40.2707 16.7837 39.1938 18.1507 38.5712C18.3657 36.9969 18.9866 35.9212 19.6716 35.3132C14.3508 34.6971 8.7574 32.6079 8.7574 23.2719C8.7574 20.6118 9.6932 18.4383 11.2256 16.732C10.9769 16.1179 10.1569 13.6402 11.4577 10.2841C11.4577 10.2841 13.4693 9.62928 18.0472 12.7816C19.9581 12.2418 22.0074 11.971 24.0432 11.9618C26.0791 11.971 28.13 12.2418 30.0444 12.7816C34.6167 9.62928 36.6256 10.2841 36.6256 10.2841C37.9295 13.6402 37.1091 16.1179 36.8604 16.732C38.3964 18.4383 39.3259 20.6118 39.3259 23.2719C39.3259 32.6301 33.7218 34.6906 28.3874 35.2938C29.2467 36.0499 30.0123 37.5327 30.0123 39.8059C30.0123 43.0655 29.9845 45.6893 29.9845 46.4922C29.9845 47.1406 30.4157 47.9003 31.63 47.6611C41.1431 44.4357 47.9984 35.3059 47.9984 24.5445C47.9984 11.0878 37.273 0.179932 24.0432 0.179932Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-52",
    d: "M9.16085 35.1623C9.10809 35.2837 8.92085 35.3196 8.75027 35.2365C8.57652 35.157 8.47893 34.992 8.53526 34.8706C8.58683 34.7459 8.77447 34.7116 8.94782 34.7943C9.12197 34.8742 9.22115 35.0408 9.16085 35.1623Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-53",
    d: "M10.131 36.2629C10.0168 36.3707 9.79346 36.3206 9.64192 36.1504C9.48523 35.9805 9.45587 35.7533 9.57171 35.644C9.68953 35.5363 9.90612 35.5867 10.0632 35.7566C10.2199 35.9285 10.2505 36.154 10.131 36.2629Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-54",
    d: "M11.0757 37.6662C10.929 37.7699 10.689 37.6727 10.5406 37.456C10.3938 37.2394 10.3938 36.9795 10.5438 36.8754C10.6925 36.7713 10.929 36.865 11.0793 37.08C11.2257 37.2999 11.2257 37.5601 11.0757 37.6662Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-55",
    d: "M12.3698 39.0219C12.2385 39.1692 11.9588 39.1297 11.7541 38.9287C11.5446 38.7322 11.4863 38.4534 11.618 38.3062C11.7509 38.1585 12.0322 38.2001 12.2385 38.3994C12.4463 38.5955 12.5098 38.8763 12.3698 39.0219Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-56",
    d: "M14.1549 39.8091C14.097 39.9999 13.8276 40.0867 13.5563 40.0056C13.2853 39.9221 13.108 39.6985 13.1628 39.5057C13.2191 39.3136 13.4896 39.2232 13.763 39.31C14.0335 39.3931 14.2112 39.615 14.1549 39.8091Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-57",
    d: "M16.1154 39.9552C16.1221 40.1561 15.892 40.3227 15.6072 40.3259C15.3208 40.3328 15.0891 40.1702 15.0859 39.9725C15.0859 39.7696 15.3109 39.6045 15.5973 39.5997C15.8821 39.594 16.1154 39.7554 16.1154 39.9552Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-58",
    d: "M17.9396 39.6392C17.9737 39.8353 17.7757 40.0367 17.4929 40.0899C17.2148 40.142 16.9574 40.0209 16.9221 39.8265C16.8876 39.6255 17.0891 39.4242 17.3668 39.3721C17.65 39.3221 17.9035 39.4399 17.9396 39.6392Z",
    fill: "#252525"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGithub);
export default __webpack_public_path__ + "static/media/logo-github.d3d09a61307c2209c53df99bb2ec49ee.svg";
export { ForwardRef as ReactComponent };